function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.67078 3H22.3861C23.8427 3 24.8107 4.50716 24.205 5.83178L22.7561 9H5.7439L4.94253 7.24767C4.03388 5.26074 5.48593 3 7.67078 3Z",
  fill: "#DCD8E5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.07871 2H20.9213C24.0335 2 25.9535 5.3978 24.3478 8.06378L17.7609 19V22.7391C17.7609 24.5401 16.3009 26 14.5 26C12.6991 26 11.2391 24.5401 11.2391 22.7391V19L4.65223 8.06378C3.0465 5.3978 4.96651 2 8.07871 2Z",
  stroke: "#DCD8E6",
  strokeWidth: 3
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 28,
  fill: "white"
})));

var SvgFunnelFirstStep = function SvgFunnelFirstStep(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFunnelFirstStep, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/funnel-first-step.1dd3e37d.svg";
export { ForwardRef as ReactComponent };